var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "position-relative height-90vh" },
    [
      _c("div", { staticClass: "scrollable-content" }, [
        _c("div", { staticClass: "row m-0 consultant-container" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 mb-15" },
            [
              _c(
                "router-link",
                {
                  staticClass: "sub-heading",
                  attrs: {
                    to: "/layout/representationresources/producttracker",
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-angle-left" }),
                  _vm._v("Update Product "),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "col-xs-12 mt-15 mb-15" }, [
            _c("div", { staticClass: "heading" }, [
              _vm._v(
                " Provide Project Contact, Product Family, Market related details below : "
              ),
            ]),
            _c("div", { staticClass: "note" }, [
              _vm._v(
                ' Note: Drop down menu only shows registered users with the role "REP Account Owner" or "REP Editor". '
              ),
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.openTeams()
                    },
                  },
                },
                [_vm._v("Click here ")]
              ),
              _vm._v(" if you want to add other contacts. "),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "col-xs-12 mt-15 mb-15" },
            [
              _c("div", { staticClass: "heading mb-15" }, [
                _vm._v("Please review/update selected country details:"),
              ]),
              _c("div", { staticClass: "col-xs-12 mt-15 mb-15" }, [
                _c("div", { staticClass: "row m-0" }, [
                  _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "form-group col-xs-12" },
                        [
                          _vm._v(" Selected Market: "),
                          _vm._l(_vm.selectedCountries, function (each) {
                            return _c("span", { key: each.id }, [
                              _vm._v(_vm._s(each.name)),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._l(
                _vm.producttracker.tracker_markets,
                function (each, index) {
                  return _c("div", { key: index, staticClass: "row mlr-15" }, [
                    _c("div", { staticClass: "col-xs-12 mb-15" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 xs-mb-15" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _vm._m(0, true),
                              _c(
                                "div",
                                { staticClass: "col-xs-12" },
                                [
                                  _c(
                                    "multiselect",
                                    {
                                      staticClass:
                                        "multiselect-single-dropdown multiselect-multiple",
                                      class: !each.tracker_contacts.length
                                        ? "un-selected"
                                        : "",
                                      attrs: {
                                        showLabels: false,
                                        "close-on-select": false,
                                        placeholder: "Select Contacts",
                                        label: "first_name",
                                        "track-by": "id",
                                        multiple: true,
                                        searchable: true,
                                        "clear-on-select": false,
                                        options: _vm.usersList,
                                        value: each.tracker_contacts,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function ({ values, isOpen }) {
                                              return _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selection-count",
                                                },
                                                [
                                                  !isOpen
                                                    ? [
                                                        _c("img", {
                                                          staticClass:
                                                            "image-size",
                                                          attrs: {
                                                            src: "/static/images/icons/filter.svg",
                                                            alt: "filter-icon",
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "selected-count",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                values.length
                                                              ) + " Selected"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : isOpen
                                                    ? [
                                                        _c("img", {
                                                          staticClass:
                                                            "image-size",
                                                          attrs: {
                                                            src: "/static/images/icons/filter.svg",
                                                            alt: "filter-icon",
                                                          },
                                                        }),
                                                      ]
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            },
                                          },
                                          {
                                            key: "option",
                                            fn: function (props) {
                                              return _c("span", {}, [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "d-flex",
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.selectedContact(
                                                          props.option.user_id,
                                                          _vm.disableContactNum,
                                                          each
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "checkbox inline-checkbox",
                                                      },
                                                      [
                                                        _c("label", [
                                                          _c("input", {
                                                            attrs: {
                                                              type: "checkbox",
                                                            },
                                                            domProps: {
                                                              value:
                                                                props.option,
                                                              checked:
                                                                each.tracker_contacts.includes(
                                                                  props.option
                                                                    .user_id
                                                                ),
                                                            },
                                                          }),
                                                          _c("span", {
                                                            staticClass: "cr",
                                                            class: {
                                                              "disabled-checkbox":
                                                                _vm.disableContactNum &&
                                                                each
                                                                  .tracker_contacts
                                                                  .length ==
                                                                  _vm.disableContactNum,
                                                            },
                                                          }),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-capitalize",
                                                        class: {
                                                          "font-bold":
                                                            each.tracker_contacts.includes(
                                                              props.option
                                                                .user_id
                                                            ),
                                                          "font-wt-400":
                                                            !each.tracker_contacts.includes(
                                                              props.option.id
                                                            ),
                                                          "disabled-text":
                                                            _vm.disableContactNum &&
                                                            !each.tracker_contacts.includes(
                                                              props.option
                                                                .user_id
                                                            ) &&
                                                            each
                                                              .tracker_contacts
                                                              .length ===
                                                              _vm.disableContactNum,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.selectedContact(
                                                              props.option
                                                                .user_id,
                                                              _vm.disableContactNum,
                                                              each
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.option
                                                                .first_name
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              props.option
                                                                .last_name
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ])
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "noResult" },
                                          slot: "noResult",
                                        },
                                        [_vm._v("No matching data")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            each.tracker_contacts.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row mt-20 col-xs-12 visible-xs",
                                  },
                                  _vm._l(
                                    each.tracker_contacts,
                                    function (contact) {
                                      return _c(
                                        "span",
                                        {
                                          key: contact,
                                          staticClass:
                                            "selected-names text-capitalize",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getContact(contact)
                                                  .first_name
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.getContact(contact)
                                                  .last_name
                                              ) +
                                              " "
                                          ),
                                          _c("img", {
                                            staticClass: "ml-10 cursor-pointer",
                                            attrs: {
                                              src: "/static/images/icons/close_blue_icon.svg",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectedContact(
                                                  contact,
                                                  _vm.disableContactNum,
                                                  each
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 xs-mt-15" },
                          [
                            _vm._m(1, true),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: each.family_name,
                                  expression: "each.family_name",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "Type",
                                maxlength: "100",
                              },
                              domProps: { value: each.family_name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    each,
                                    "family_name",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]
                        ),
                        each.tracker_contacts.length
                          ? _c(
                              "div",
                              { staticClass: "mt-20 col-xs-12 hidden-xs" },
                              _vm._l(each.tracker_contacts, function (contact) {
                                return _c(
                                  "span",
                                  {
                                    key: contact,
                                    staticClass:
                                      "selected-names text-capitalize",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getContact(contact).first_name
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.getContact(contact).last_name
                                        ) +
                                        " "
                                    ),
                                    _c("img", {
                                      staticClass: "ml-10 cursor-pointer",
                                      attrs: {
                                        src: "/static/images/icons/close_blue_icon.svg",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectedContact(
                                            contact,
                                            _vm.disableContactNum,
                                            each
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-xs-12 mb-15 mt-15" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 xs-mb-15" },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _vm._v(" GMDN/EMDN"),
                              each.country_id !== 250
                                ? _c(
                                    "span",
                                    { staticClass: "required-astreisk" },
                                    [_vm._v("*")]
                                  )
                                : _c("span", [_vm._v(" (Optional)")]),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: each.gmdn_emdn_cd,
                                  expression: "each.gmdn_emdn_cd",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "Type",
                                maxlength: "100",
                              },
                              domProps: { value: each.gmdn_emdn_cd },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    each,
                                    "gmdn_emdn_cd",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 xs-mt-15" },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _vm._v("Classification"),
                            ]),
                            _c(
                              "multiselect",
                              {
                                staticClass: "multiselect-single-dropdown",
                                attrs: {
                                  showLabels: false,
                                  "close-on-select": true,
                                  "allow-empty": false,
                                  searchable: false,
                                  options: _vm
                                    .filterByCountry(
                                      _vm.classificationList,
                                      each.country_id
                                    )
                                    .map((e) => e.id),
                                  "custom-label": (option) =>
                                    _vm
                                      .filterByCountry(
                                        _vm.classificationList,
                                        each.country_id
                                      )
                                      .find((e) => e.id == option).name,
                                  placeholder: "Select Classification",
                                },
                                on: {
                                  select: function ($event) {
                                    return _vm.checkClassification($event, each)
                                  },
                                },
                                model: {
                                  value: each.class_id,
                                  callback: function ($$v) {
                                    _vm.$set(each, "class_id", $$v)
                                  },
                                  expression: "each.class_id",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "noResult" },
                                    slot: "noResult",
                                  },
                                  [_vm._v("No matching data")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    each.country_id !== 14 && each.country_id !== 216
                      ? _c("div", { staticClass: "col-xs-12 mt-15 mb-15" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-6" },
                              [
                                _c("div", { staticClass: "form-group" }, [
                                  _vm._v("Additional Legislation"),
                                ]),
                                _c(
                                  "multiselect",
                                  {
                                    staticClass:
                                      "multiselect-single-dropdown multiselect-multiple",
                                    attrs: {
                                      showLabels: false,
                                      "close-on-select": false,
                                      placeholder: "Select Directives",
                                      multiple: true,
                                      searchable: true,
                                      "clear-on-select": false,
                                      options: _vm.filterByCountry(
                                        _vm.directivesList,
                                        each.country_id
                                      ),
                                      value: each.directives,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function ({ isOpen }) {
                                            return _c(
                                              "div",
                                              {
                                                staticClass: "selection-count",
                                              },
                                              [
                                                !isOpen
                                                  ? [
                                                      _c("img", {
                                                        staticClass:
                                                          "image-size",
                                                        attrs: {
                                                          src: "/static/images/icons/filter.svg",
                                                          alt: "filter-icon",
                                                        },
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "selected-count",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              each.directives
                                                                .length
                                                            ) + " Selected"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : isOpen
                                                  ? [
                                                      _c("img", {
                                                        staticClass:
                                                          "image-size",
                                                        attrs: {
                                                          src: "/static/images/icons/filter.svg",
                                                          alt: "filter-icon",
                                                        },
                                                      }),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            )
                                          },
                                        },
                                        {
                                          key: "option",
                                          fn: function (props) {
                                            return _c("span", {}, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "d-flex",
                                                  on: {
                                                    input: function ($event) {
                                                      return _vm.updateSelectedDirective(
                                                        props.option.id,
                                                        each.directives
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "checkbox inline-checkbox",
                                                    },
                                                    [
                                                      _c("label", [
                                                        _c("input", {
                                                          attrs: {
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            value: props.option,
                                                            checked:
                                                              each.directives &&
                                                              each.directives.includes(
                                                                props.option.id
                                                              ),
                                                          },
                                                        }),
                                                        _c("span", {
                                                          staticClass: "cr",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "font-bold":
                                                          each.directives &&
                                                          each.directives.includes(
                                                            props.option.id
                                                          ),
                                                        "font-wt-400":
                                                          !each.directives ||
                                                          each.directives.includes(
                                                            props.option.id
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.updateSelectedDirective(
                                                            props.option.id,
                                                            each.directives
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            props.option.code
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ])
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "noResult" },
                                        slot: "noResult",
                                      },
                                      [_vm._v("No matching data")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            each.directives && each.directives.length
                              ? _c(
                                  "div",
                                  { staticClass: "col-xs-12 mt-20" },
                                  _vm._l(each.directives, function (directive) {
                                    return _c(
                                      "span",
                                      {
                                        key: directive,
                                        staticClass: "selected-names",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getDirectiveName(
                                                directive,
                                                each.country_id
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c("img", {
                                          staticClass: "ml-10 cursor-pointer",
                                          attrs: {
                                            src: "/static/images/icons/close_blue_icon.svg",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateSelectedDirective(
                                                directive,
                                                each.directives
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "col-xs-12 mt-15" }, [
                      _c("div", { staticClass: "row m-0" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 custom-box heading flex-between",
                          },
                          [
                            _c("div", { staticClass: "heading" }, [
                              _vm._v(
                                " " +
                                  _vm._s(each.trade_names.length) +
                                  " Trade Name(s)"
                              ),
                              _c("span", { staticClass: "required-astreisk" }, [
                                _vm._v("*"),
                              ]),
                            ]),
                            _c("div", [
                              _c(
                                "a",
                                {
                                  staticClass: "cursor-pointer mr-30",
                                  attrs: {
                                    disabled:
                                      _vm.selectedTrades[each.country_id] &&
                                      _vm.selectedTrades[each.country_id]
                                        .length < 2,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.checkTradeRemoval(each)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "table-link-img-size",
                                    attrs: {
                                      src: "/static/images/icons/delete_icon.svg",
                                      alt: "",
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "table-link-font text-emergo-red hidden-xs",
                                    },
                                    [_vm._v(" Remove ")]
                                  ),
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.addTrade(each)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "table-link-img-size",
                                    attrs: {
                                      src: "/static/images/icons/plus_icon_blue.svg",
                                      alt: "",
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "table-link-font text-emergo-dark-blue hidden-xs",
                                    },
                                    [_vm._v(" Add ")]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        each.trade_names.length
                          ? _c(
                              "table",
                              { staticClass: "col-xs-12 table trade-table" },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", { staticClass: "wd-30px" }, [
                                      _c("span", { staticClass: "checkbox" }, [
                                        _c("label", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.selectAllTrades[
                                                    each.country_id
                                                  ],
                                                expression:
                                                  "selectAllTrades[each.country_id]",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.selectAllTrades[
                                                  each.country_id
                                                ]
                                              )
                                                ? _vm._i(
                                                    _vm.selectAllTrades[
                                                      each.country_id
                                                    ],
                                                    null
                                                  ) > -1
                                                : _vm.selectAllTrades[
                                                    each.country_id
                                                  ],
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a =
                                                      _vm.selectAllTrades[
                                                        each.country_id
                                                      ],
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.selectAllTrades,
                                                          each.country_id,
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.selectAllTrades,
                                                          each.country_id,
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.selectAllTrades,
                                                      each.country_id,
                                                      $$c
                                                    )
                                                  }
                                                },
                                                function ($event) {
                                                  return _vm.selectAllTradesMethod(
                                                    each.country_id,
                                                    each.trade_names
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                          _c("span", { staticClass: "cr" }),
                                        ]),
                                      ]),
                                    ]),
                                    _c("th", [
                                      _vm._v(" Trade Name "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "sort sortPosition",
                                          class: _vm.sortOrders["name"]
                                            ? "asc"
                                            : "desc",
                                          on: {
                                            click: function ($event) {
                                              return _vm.sortBy("name")
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: "/static/images/icons/sortDesc.svg",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                    _c("th"),
                                  ]),
                                ]),
                                _c(
                                  "tbody",
                                  _vm._l(
                                    each.trade_names,
                                    function (trade, index) {
                                      return _c("tr", { key: index }, [
                                        _c("td", { staticClass: "wd-30px" }, [
                                          _c(
                                            "span",
                                            { staticClass: "checkbox top-2" },
                                            [
                                              _c("label", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.selectedTrades[
                                                          each.country_id
                                                        ],
                                                      expression:
                                                        "selectedTrades[each.country_id]",
                                                    },
                                                  ],
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    value: trade,
                                                    checked: Array.isArray(
                                                      _vm.selectedTrades[
                                                        each.country_id
                                                      ]
                                                    )
                                                      ? _vm._i(
                                                          _vm.selectedTrades[
                                                            each.country_id
                                                          ],
                                                          trade
                                                        ) > -1
                                                      : _vm.selectedTrades[
                                                          each.country_id
                                                        ],
                                                  },
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        var $$a =
                                                            _vm.selectedTrades[
                                                              each.country_id
                                                            ],
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = trade,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.selectedTrades,
                                                                each.country_id,
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.selectedTrades,
                                                                each.country_id,
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.selectedTrades,
                                                            each.country_id,
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                      function ($event) {
                                                        return _vm.updateSelection(
                                                          each.trade_names,
                                                          $event,
                                                          each.country_id,
                                                          trade
                                                        )
                                                      },
                                                    ],
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "cr",
                                                }),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                        _c("td", [_vm._v(_vm._s(trade))]),
                                        _c(
                                          "td",
                                          { staticClass: "align-right wd-30" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "cursor-pointer mr-30",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.checkTradeRemoval(
                                                      each,
                                                      true,
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "table-link-img-size",
                                                  attrs: {
                                                    src: "/static/images/icons/delete_icon.svg",
                                                    alt: "",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "table-link-font text-emergo-red hidden-xs",
                                                  },
                                                  [_vm._v(" Remove ")]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "cursor-pointer",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.updateTrade(
                                                      trade,
                                                      each,
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "table-link-img-size",
                                                  attrs: {
                                                    src: "/static/images/icons/edit_icon.svg",
                                                    alt: "",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "table-link-font text-emergo-dark-blue hidden-xs",
                                                  },
                                                  [_vm._v(" Update ")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ])
                }
              ),
            ],
            2
          ),
        ]),
      ]),
      _c("div", { staticClass: "row col-xs-12 m-0 footer" }, [
        _c(
          "div",
          {
            staticClass: "col-xs-4 col-sm-3 col-md-2",
            class: {
              "col-xs-offset-4 col-md-offset-8 col-sm-offset-6":
                _vm.userData.role_id === 12,
            },
          },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-block emergo-white-button",
                attrs: { to: "/layout/representationresources/producttracker" },
              },
              [_vm._v("Cancel")]
            ),
          ],
          1
        ),
        _vm.userData.role_id === 9 || _vm.userData.role_id === 8
          ? _c(
              "div",
              {
                staticClass:
                  "col-xs-4 col-sm-offset-3 col-sm-3 col-md-offset-6 col-md-2",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block emergo-white-button",
                    attrs: { disabled: _vm.disableSubmit },
                    on: {
                      click: function ($event) {
                        return _vm.saveProduct("draft")
                      },
                    },
                  },
                  [_vm._v(" Save ")]
                ),
              ]
            )
          : _vm._e(),
        _c("div", { staticClass: "col-xs-4 col-sm-3 col-md-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-block emergo-green-button",
              attrs: { disabled: _vm.disableSubmit },
              on: {
                click: function ($event) {
                  _vm.userData.role_id === 12
                    ? _vm.saveProduct("update")
                    : _vm.submitPopup()
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.userData.role_id === 12 ? "Update" : "Submit") +
                  " "
              ),
            ]
          ),
        ]),
      ]),
      _c("loader", {
        attrs: {
          loadingStatus:
            _vm.loaderStatus === true || _vm.loaderStatus === "page",
        },
      }),
      _c(
        "div",
        {
          staticClass: "modal fade trade-popup",
          attrs: { id: "addTradePopup", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header generic-header" }, [
                _vm.tradeIndex !== null && _vm.tradeIndex > -1
                  ? _c("span", [_vm._v("Update")])
                  : _c("span", [_vm._v("Add")]),
                _c("span", [_vm._v(" Trade Name")]),
                _c("img", {
                  staticClass: "close-icon cursor-pointer",
                  attrs: { src: "/static/images/icons/close_icon.svg" },
                  on: { click: _vm.closePopupOnOk },
                }),
              ]),
              _c("div", { staticClass: "modal-body generic-body" }, [
                _c("div", { staticClass: "trade-box" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _vm._v("Trade Name"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.tradeName,
                        expression: "tradeName",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "form-control",
                    class: { "invalid-border": _vm.showTradeError },
                    attrs: { maxlength: "100", placeholder: "Trade name" },
                    domProps: { value: _vm.tradeName },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.tradeName = $event.target.value.trim()
                        },
                        function ($event) {
                          _vm.showTradeError = ""
                        },
                      ],
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm.showTradeError
                    ? _c("div", { staticClass: "custom-error-class pt-5" }, [
                        _vm._v(" " + _vm._s(_vm.showTradeError) + " "),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "modal-footer", staticStyle: { clear: "both" } },
                [
                  _c("div", { staticClass: "col-xs-6 pl-0" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-white-button",
                        attrs: { type: "button" },
                        on: { click: _vm.closePopupOnOk },
                      },
                      [_vm._v(" Cancel ")]
                    ),
                  ]),
                  _vm.tradeIndex !== null && _vm.tradeIndex > -1
                    ? _c("div", { staticClass: "col-xs-6 pr-0" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-block emergo-green-button",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.UpdateTradeModal()
                              },
                            },
                          },
                          [_vm._v(" Update ")]
                        ),
                      ])
                    : _c("div", { staticClass: "col-xs-6 pr-0" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-block emergo-green-button",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.AddTradeModal()
                              },
                            },
                          },
                          [_vm._v(" Add ")]
                        ),
                      ]),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade submit-popup",
          attrs: { id: "removeTradePopup", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(2),
              _vm._m(3),
              _c(
                "div",
                { staticClass: "modal-footer", staticStyle: { clear: "both" } },
                [
                  _vm._m(4),
                  _c("div", { staticClass: "col-xs-6 pr-0" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.submitRemoveTrade()
                          },
                        },
                      },
                      [_vm._v(" Submit ")]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade submit-popup",
          attrs: { id: "submitPopup", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _vm._m(5),
                _vm._m(6),
                _c(
                  "div",
                  {
                    staticClass: "modal-footer",
                    staticStyle: { clear: "both" },
                  },
                  [
                    _vm._m(7),
                    _c("div", { staticClass: "col-xs-6 pr-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-green-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.saveProduct()
                            },
                          },
                        },
                        [_vm._v(" Submit ")]
                      ),
                    ]),
                  ]
                ),
                _c("loader", {
                  attrs: { loadingStatus: _vm.loaderStatus === "modal" },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._m(8),
      _c("Classification-Confirmation-Popup", {
        attrs: {
          popupData: _vm.classificationPopupData,
          title: _vm.classificationTitle,
        },
        on: {
          closeConfirmationPopup: _vm.closeClassificationConfirmationPopup,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group col-xs-12" }, [
      _vm._v(" Select Project Contacts"),
      _c("span", { staticClass: "required-astreisk" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group" }, [
      _vm._v(" Add Product Family Name"),
      _c("span", { staticClass: "required-astreisk" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header generic-header" }, [
      _c("img", {
        staticClass: "close-icon cursor-pointer",
        attrs: {
          src: "/static/images/icons/close_icon.svg",
          "data-dismiss": "modal",
          "data-target": "#removeTradePopup",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body center pt-0" }, [
      _c("img", {
        staticClass: "info-icon",
        attrs: { src: "/static/images/icons/expiring_yellow.svg" },
      }),
      _c("div", { staticClass: "sub-header" }, [
        _vm._v("Are you sure you would like to delete the Trade Name?"),
      ]),
      _c("div", { staticClass: "sub-text" }, [
        _vm._v(" Once deleted, you cannot recover the "),
        _c("br"),
        _vm._v("information again. "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-6 pl-0" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-block emergo-white-button",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "data-target": "#removeTradePopup",
          },
        },
        [_vm._v(" Cancel ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header generic-header" }, [
      _c("img", {
        staticClass: "close-icon cursor-pointer",
        attrs: {
          src: "/static/images/icons/close_icon.svg",
          "data-dismiss": "modal",
          "data-target": "#submitPopup",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body center pt-0" }, [
      _c("img", {
        staticClass: "info-icon",
        attrs: { src: "/static/images/icons/expiring_yellow.svg" },
      }),
      _c("div", { staticClass: "sub-header" }, [
        _vm._v("Are you sure you want to submit the details?"),
      ]),
      _c("div", { staticClass: "sub-text" }, [
        _vm._v(
          " You cannot directly edit the entries after submission and you will need to “Request Modification” to edit submitted entries. Only “Draft” entries can be directly edited again. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-6 pl-0" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-block emergo-white-button",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "data-target": "#submitPopup",
          },
        },
        [_vm._v(" Cancel ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "modal fade submit-popup",
        attrs: { id: "submitErrorPopup", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header generic-header" }, [
              _c("img", {
                staticClass: "close-icon cursor-pointer",
                attrs: {
                  src: "/static/images/icons/close_icon.svg",
                  "data-dismiss": "modal",
                  "data-target": "#submitErrorPopup",
                },
              }),
            ]),
            _c("div", { staticClass: "modal-body center pt-0" }, [
              _c("img", {
                staticClass: "info-icon",
                attrs: { src: "/static/images/icons/alert_triangle.svg" },
              }),
              _c("div", { staticClass: "sub-header" }, [
                _vm._v(
                  " You cannot proceed further as you did not fill the mandatory details "
                ),
              ]),
              _c("div", { staticClass: "sub-text" }, [
                _vm._v(
                  " Kindly provide the “GMDN/EMDN” details and atleast one ”Trade Name” for the required countries to submit the product request. "
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "modal-footer", staticStyle: { clear: "both" } },
              [
                _c("div", { staticClass: "col-xs-offset-3 col-xs-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-green-button",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "data-target": "#submitErrorPopup",
                      },
                    },
                    [_vm._v(" OK ")]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }